// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-accordion-list-editor[data-v-0e455a2f]{display:flex;flex-direction:column;gap:10px}.clickable[data-v-0e455a2f]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
